import { render, staticRenderFns } from "./FaturamentoDevolucaoImpropriaVendedor.vue?vue&type=template&id=7f85a5e5&scoped=true&"
import script from "./FaturamentoDevolucaoImpropriaVendedor.vue?vue&type=script&lang=js&"
export * from "./FaturamentoDevolucaoImpropriaVendedor.vue?vue&type=script&lang=js&"
import style0 from "./FaturamentoDevolucaoImpropriaVendedor.vue?vue&type=style&index=0&id=7f85a5e5&scoped=true&lang=css&"
import style1 from "./FaturamentoDevolucaoImpropriaVendedor.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f85a5e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
